import { render } from "./AddUser.vue?vue&type=template&id=2f1e2b04&ts=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__